"use client";

import './index.css';
import { __rest } from '../../_virtual/_tslib.js';
import { jsx } from 'react/jsx-runtime';
import { Children, isValidElement } from 'react';
import { validateSurface } from '../../globals.js';
import styles from './breadcrumbs.module.scss.js';
import { BreadcrumbItem } from './breadcrumb-item.js';

/**
 * @component Breadcrumbs
 * @package Breadcrumbs
 * @document ../_docs/code/Breadcrumbs.import.tsx
 * @document ../_docs/code/Breadcrumbs.editor.tsx
 * @document ../_docs/code/Breadcrumbs.snippet.tsx
 */
const Breadcrumbs = (_a) => {
    var { ariaLabel, children, surface: surfaceProp = 'lightPrimary', items: breadCrumbItems } = _a, rest = __rest(_a, ["ariaLabel", "children", "surface", "items"]);
    const calculateAriaLabel = (elementProps) => {
        if (elementProps && (elementProps['aria-label'] || elementProps.ariaLabel))
            return elementProps['aria-label'] || elementProps.ariaLabel;
        return '';
    };
    // Normalize the surface prop
    const surface = validateSurface(surfaceProp);
    const breadcrumbsStyles = [styles.breadcrumbs, styles[surface.toLowerCase()]];
    const renderBreadcrumbsFromChildren = () => {
        if (!children) {
            return null;
        }
        const validChildren = Children.toArray(children).filter(Boolean);
        const childCount = validChildren.length;
        return validChildren.map((child, index) => {
            if (isValidElement(child) && child.type === BreadcrumbItem) {
                const childProps = child.props;
                return (jsx("li", { className: childProps.selected ? styles.selected : undefined, children: jsx(BreadcrumbItem, Object.assign({}, childProps, { ariaLabel: calculateAriaLabel(childProps), lastItem: index === childCount - 1 })) }));
            }
            return jsx("li", { children: child });
        });
    };
    const renderBreadcrumbsFromItems = () => {
        if (!breadCrumbItems || breadCrumbItems.length === 0) {
            return null;
        }
        return breadCrumbItems.map((item, index, items) => (jsx("li", { className: item.selected ? styles.selected : undefined, children: jsx(BreadcrumbItem, Object.assign({}, item, { lastItem: index === items.length - 1,
                ariaLabel: calculateAriaLabel(item) })) })));
    };
    const renderContent = () => {
        if (breadCrumbItems) {
            return renderBreadcrumbsFromItems();
        }
        return renderBreadcrumbsFromChildren();
    };
    return (jsx("nav", Object.assign({}, rest, { className: breadcrumbsStyles.join(' '), "aria-label": calculateAriaLabel(Object.assign(Object.assign({}, rest), { ariaLabel })), children: jsx("ol", { children: renderContent() }) })));
};

export { Breadcrumbs, Breadcrumbs as default };
